import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let ArmorProperties = class ArmorProperties extends VuexModule {
    constructor() {
        super(...arguments);
        this.armorProperties = [];
        this.cachedVersion = 0;
    }
    async fetchArmorProperties() {
        const { data: armorProperties, cachedVersion } = await fetchFromCache(this, 'armorProperties', 'armorProperty');
        return { armorProperties, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['armorProperties', 'cachedVersion'] })
], ArmorProperties.prototype, "fetchArmorProperties", null);
ArmorProperties = __decorate([
    Module({ namespaced: true, name: 'armorProperties' })
], ArmorProperties);
export default ArmorProperties;
